import React from 'react';
import { chapters } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Chapters() {
  return <section aria-labelledby="capitulos-title" className="w-full bg-ink-800" data-id="element-33" data-mp="3cytmv7yqllaq">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-34" data-mp="2yyivm3tim4p1">
        <div className="max-w-3xl" data-id="element-35" data-mp="330vy8jcytmhl">
          <SectionLabel data-id="element-36" data-mp="3304a1tlp6r1c">El método completo</SectionLabel>
          <h2 id="capitulos-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-37" data-mp="2p9r765nny2iv">
            Los 4 pilares que protegen la carrera de su hijo
          </h2>
          <p className="mt-4 text-base leading-relaxed text-body" data-id="element-38" data-mp="2fcmhvwyitqxu">
            Primero entiende cómo funciona el fútbol formativo bajo el marco de FIFA, con ejemplos
            aplicados a Colombia. Después trabaja el Triángulo de Blindaje: Legalidad, Visibilidad y
            Biología. Cuando uno de ellos falla, aparecen los problemas: contratos que nadie leyó,
            talento que nunca llega a los ojos correctos y cuerpos exigidos de más.
          </p>
        </div>
        <div className="mt-10 space-y-5" data-id="element-39" data-mp="2fhl1j22focqe">
          {chapters.map(chapter => <article key={chapter.number} className="flex flex-col gap-5 rounded-xl border border-ink-border border-l-[5px] border-l-brand-green bg-ink-card p-6 shadow-panel transition-colors duration-150 ease-out hover:border-brand-green/50 hover:border-l-brand-green sm:flex-row md:p-8" data-id="element-40" data-mp="2tgt1vyac1qw6">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-greenDeep font-display text-xl font-black text-brand-greenSoft" data-id="element-41" data-mp="1vtu6dqvdmozv">
                {chapter.number}
              </div>
              <div data-id="element-42" data-mp="25qgpob8217zs">
                <h3 className="font-display text-xl font-bold text-white md:text-2xl" data-id="element-43" data-mp="25p5jy5v1tq61">
                  {chapter.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-44" data-mp="1d32zqx2rxcp6">{chapter.description}</p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-45" data-mp="3d5caimxj9j96">
                  {chapter.tags.map(tag => <li key={tag} className="rounded-full bg-brand-greenDeep px-3 py-1 text-xs font-semibold text-brand-greenSoft" data-id="element-46" data-mp="3i33y54r5aj7k">
                      {tag}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}